export default {"src":"/_next/static/media/vrc.b5a0a8be.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};